import { Link } from "react-router-dom";
import { CATEGORY_LABEL } from "@/data/products";

export function ProductCard({ product }) {
  return (
    <article className="group border border-border bg-white" data-testid={`product-card-${product.id}`}>
      <div className="relative overflow-hidden">
        <img
          src={product.image}
          alt={`${product.name} — ${CATEGORY_LABEL[product.category]} sample style`}
          loading="lazy"
          className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-sm bg-indigo-deep/90 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-gold">
          Sample
        </span>
      </div>
      <div className="p-5">
        <p className="text-[11px] font-semibold uppercase tracking-widest text-gold">{CATEGORY_LABEL[product.category]}</p>
        <h3 className="mt-1 font-display text-lg font-semibold text-indigo">{product.name}</h3>
        <p className="mt-1 text-xs text-muted-foreground">Fit: {product.fit} · Wash: {product.wash}</p>
        <p className="mt-2 text-sm leading-relaxed text-foreground/70">{product.description}</p>
        <Link
          to={`/request-a-quote?product=${encodeURIComponent(CATEGORY_LABEL[product.category])}`}
          data-testid={`product-enquire-${product.id}`}
          className="mt-4 inline-block border-b-2 border-gold pb-0.5 text-sm font-semibold text-indigo transition-colors hover:text-gold-dark"
        >
          Enquire about this range
        </Link>
      </div>
    </article>
  );
}
